import React, { useRef } from "react";
import clsx from "clsx";

import { CheckboxProps } from "./types";
import TickSVG from "modules/theme/icons/general/tick.svg";
import Label from "components/Label";

import * as styles from "./styles.module.scss";

const Checkbox: React.FunctionComponent<CheckboxProps> = ({
  disabled,
  children,
  checked,
  forwardedRef,
  id,
  invalid,
  label,
  name,
  onBlur,
  onChange,
  onFocus,
  onLabelClick,
  onLabelKeyDown,
  readOnly,
  value,
}) => {
  const checkboxRef = forwardedRef ? forwardedRef : useRef<HTMLInputElement | null>(null);
  const className = clsx(
    styles.checkbox,
    disabled && styles.disabled,
    !disabled && invalid && styles.invalid,
    readOnly && styles.readOnly
  );
  return (
    <div className={className}>
      <input
        checked={checked}
        disabled={disabled}
        id={id}
        name={name}
        onBlur={onBlur}
        onChange={onChange}
        onFocus={onFocus}
        ref={checkboxRef}
        tabIndex={-1}
        type="checkbox"
        value={value}
      />
      <TickSVG />
      {label && (
        <Label id={id} label={label} onClick={onLabelClick} onKeyDown={onLabelKeyDown}>
          {children}
        </Label>
      )}
    </div>
  );
};

export default React.memo(Checkbox);
